<template>
  <div class="flex min-h-screen flex-col">
    <AgentsHeader variant="black" />
    <main>
      <slot />
    </main>
    <AgentsFooter />
  </div>
</template>

<script setup lang="ts">
import { useOrganizationSchema, useWebsiteSchema } from '~/composables/useSchemaOrg';

// Site-wide JSON-LD foundations so / (and any other agents-layout route)
// emits the knowledge-panel Organization + sitelinks-searchbox WebSite
// blocks. The default layout already calls these — this layout was
// missing them, leaving /agents with zero structured data.
useOrganizationSchema();
useWebsiteSchema();
</script>

<style scoped></style>
